module.exports = __webpack_public_path__ + "static/media/gasing.ea43b8e3.mp4";


/*****************
 ** WEBPACK FOOTER
 ** ./media/videos/gasing.mp4
 ** module id = 451
 ** module chunks = 0
 **/